import React from "react";
import { CMSData } from "@/cms/models";
import MuiCheckbox from "@mui/material/Checkbox";
import { FormControlLabel } from "@mui/material";
import { twMerge } from "tailwind-merge";
interface CheckboxInputProps {
  label: string;
  isChecked: boolean;
  cmsData: CMSData;
  className?: string;
  name?: string;
  wrap?: boolean;
  onChanged: (checked: boolean) => void;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
  label,
  isChecked,
  cmsData,
  name,
  wrap,
  onChanged,
  className,
}) => {
  const style = cmsData.forms.style;
  return (
    <FormControlLabel
      className={twMerge("!homepage-text-lg", !wrap && "truncate", className)}
      slotProps={
        wrap
          ? {
              typography: {
                className: "!overflow-visible !whitespace-normal",
              },
            }
          : undefined
      }
      control={
        <MuiCheckbox
          size={style?.size}
          name={name}
          checked={isChecked}
          onChange={(e) => onChanged(e.target.checked)}
        />
      }
      label={
        <span className={wrap ? "!whitespace-normal" : "truncate"}>
          {label}
        </span>
      }
    />
  );
};

export default CheckboxInput;
